import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class EScheduleService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getAgentList(userId: string): Observable<any> {
    return this.httpHelperService.get(`/common/agents?userId=${userId}`);
  }

  public getProductList(userId: string): Observable<any> {
    return this.httpHelperService.get(`/common/lov/products?userId=${userId}`);
  }

  public getCallCenterAgentList(payload: {
    userId: string;
    criteria: string;
    criteriaValue: string;
  }): Observable<any> {
    const params = new HttpParams()
      .set("userId", payload.userId)
      .set("criteria", payload.criteria);
    if (payload.criteriaValue) {
      params.set("criteriaValue", payload.criteriaValue);
    }
    return this.httpHelperService.get("/common/agents", params);
  }
}
